module.exports = __webpack_public_path__ + "img/87127.ee866e57.svg";